// Storage keys are centralized in `constants/storageKeys.ts` (DATA-001). The
// duplicate STORAGE_KEYS object that used to live here — a Bolt-scaffold
// leftover with the stale `bolt-auth-token` name — was removed; nothing
// imported it. Auth-token keys live in `AUTH_STORAGE_KEYS` (`prompt-auth-token`).

export const MESSAGE_TYPES = {
  AUTH: 'auth',
  SETTINGS: 'settings',
  SYNC: 'sync',
  CONNECTION: 'checkConnection',
  AUTH_UPDATE: 'AUTH_UPDATE',
  SETTINGS_UPDATE: 'SETTINGS_UPDATE',
  PREMIUM_STATUS_UPDATE: 'PREMIUM_STATUS_UPDATE',
  THEME_UPDATE: 'THEME_UPDATE',
  GET_INIT_STATUS: 'GET_INIT_STATUS',
  INIT_COMPLETE: 'INIT_COMPLETE',
  EXTENSION_READY: 'EXTENSION_READY',
  UI_READY: 'UI_READY',
  UI_ACTION: 'UI_ACTION',
  // UI → background nudge to re-run the Stripe billing reconcile now (sent by
  // the Firestore onSnapshot listener while a UI surface is open).
  BILLING_REFRESH: 'BILLING_REFRESH',
} as const;

export const UI_ACTIONS = {
  openPopup: 'openPopup',
  openFullscreen: 'openFullscreen',
  openSidePanel: 'openSidePanel',
} as const;

export const AUTH_ACTIONS = {
  SIGN_IN: 'signIn',
  SIGN_UP: 'signUp',
  SIGN_OUT: 'signOut',
  GET_SESSION: 'getSession',
} as const;

export const SYNC_ACTIONS = {
  INITIALIZE: 'initialize',
  SYNC: 'sync',
} as const;

export const SETTINGS_ACTIONS = {
  GET: 'get',
  UPDATE: 'update',
  INITIALIZE: 'initialize',
} as const;

export const DEFAULT_SETTINGS = {
  THEME: 'system',
  PREMIUM_STATUS: 'free',
} as const;

export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];
export type UIAction = (typeof UI_ACTIONS)[keyof typeof UI_ACTIONS];
export type AuthAction = (typeof AUTH_ACTIONS)[keyof typeof AUTH_ACTIONS];
export type SyncAction = (typeof SYNC_ACTIONS)[keyof typeof SYNC_ACTIONS];
export type SettingsAction = (typeof SETTINGS_ACTIONS)[keyof typeof SETTINGS_ACTIONS];
